







import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {Prop, Watch} from 'vue-property-decorator';
import '@/compiled-icons/download';
import {PDFPageProxy, PDFPageViewport, PDFRenderParams, PDFRenderTask} from 'pdfjs-dist';

@Component({
  mixins: [BindAttrs]
})
export default class PDFPage extends Vue {
  @Prop({
    required: true
  }) page!: PDFPageProxy;
  @Prop({
    required: true
  }) scale!: number;
  height: number = 0;
  width: number = 0;
  viewport: PDFPageViewport | undefined;

  $refs!: {
    canvas: HTMLCanvasElement
  };

  private renderTask: PDFRenderTask | undefined;

  @Watch('page') onPageChanged(newPage: PDFPageProxy, oldPage: PDFPageProxy) {
    this.destroyPage(oldPage);
  }

  @Watch('scale') onScaleChanged(newScale: number, oldScale: number) {
    this.viewport = this.page.getViewport({
      scale: newScale
    });
    this.height = this.viewport.height;
    this.width = this.viewport.width;
    this.drawPage();
  }

  created() {
    this.viewport = this.page.getViewport({
      scale: this.scale
    });
    this.height = this.viewport.height;
    this.width = this.viewport.width;
  }

  mounted() {
    this.drawPage();
  }

  drawPage() {
    if (this.renderTask) {
      this.destroyRenderTask();
    }

    const canvasContext: CanvasRenderingContext2D | null = this.$refs.canvas.getContext('2d');
    if (canvasContext) {
      const renderContext: PDFRenderParams = {
        canvasContext,
        viewport: this.viewport
      };
      this.renderTask = this.page.render(renderContext);
    }
  }

  beforeDestroy() {
    this.destroyPage(this.page);
  }

  destroyPage(page: PDFPageProxy) {
    if (!page) {
      return;
    }
    (page as any)._destroy();
    if (this.renderTask) {
      this.renderTask.cancel();
    }
  }

  destroyRenderTask() {
    if (!this.renderTask) {
      return;
    }
    this.renderTask.cancel();
    delete this.renderTask;
  }
}
